import type { ReactNode } from "react";
import { cn } from "../../utils/common/cn";

export function Panel({
  id,
  title,
  description,
  right,
  rightAlign = "start",
  children,
  className,
}: {
  id?: string;
  title: string;
  description?: string;
  right?: ReactNode;
  /** Where `right` sits against the title block: "start" (top, the default, wrapping below the text when narrow) or
   *  "center" (level with its text, on the same row: the text wraps instead of pushing `right` underneath). */
  rightAlign?: "start" | "center";
  children: ReactNode;
  className?: string;
}) {
  return (
    <section id={id} className={cn("border border-border bg-card p-5", className)}>
      <div
        className={cn(
          "flex justify-between gap-4",
          rightAlign === "center" ? "flex-nowrap items-center" : "flex-wrap items-start",
        )}
      >
        <div className={rightAlign === "center" ? "min-w-0" : undefined}>
          <h2 className="text-sm font-semibold uppercase tracking-wider text-foreground">
            {title}
          </h2>
          {description ? (
            <p className="mt-1 text-xs text-muted-foreground">{description}</p>
          ) : null}
        </div>
        {right ? <div className="shrink-0">{right}</div> : null}
      </div>
      <div className="mt-5">{children}</div>
    </section>
  );
}

export function ChartTooltipShell({ children }: { children: ReactNode }) {
  return (
    <div className="border border-border bg-background/95 px-3 py-2 text-xs shadow-lg">
      {children}
    </div>
  );
}
